import React from 'react';
import BaseIcon from '../base-icon';

const Dismiss = (props) => (
  <BaseIcon viewBox="2 2 24 24" {...props} scalable>
    <path d="M18 18.5a.47.47 0 01-.35-.15l-8-8a.49.49 0 01.7-.7l8 8a.48.48 0 010 .7.47.47 0 01-.35.15z" />
    <path d="M10 18.5a.47.47 0 01-.35-.15.48.48 0 010-.7l8-8a.49.49 0 11.7.7l-8 8a.47.47 0 01-.35.15z" />
  </BaseIcon>
);

export default Dismiss;
